import { render, staticRenderFns } from "./ScormPlayer.vue?vue&type=template&id=4ef9d52c&scoped=true&"
import script from "./ScormPlayer.vue?vue&type=script&lang=ts&"
export * from "./ScormPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./ScormPlayer.vue?vue&type=style&index=0&id=4ef9d52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef9d52c",
  null
  
)

export default component.exports